(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ginkgoch-buffer-io"] = factory();
	else
		root["ginkgoch-buffer-io"] = factory();
})(global, function() {
return 